import { cdnRoot } from '../services/services'

export const YOUR_STORIES_PATH = '/your-stories'
const FAMILY_STORIES_PATH = '/family-stories'
const FAMILY_FEED_PATH = '/family-feed'
const TEMPLE_PATH = '/temple'
const ACTIVITIES_PATH = '/activities'
const INVITE_FAMILY_MEMBERS_PATH = '/invite-family-members'
// const OVER_LIMIT_PATH = '/over-limit'

const imageRoot = `${cdnRoot}/connect/landing/v1`

export default (showTemple) => {
  return [
    {
      path: YOUR_STORIES_PATH,
      title: 'invitation.your-stories',
      icon: `${imageRoot}/heart-icon.svg`,
      description: 'invitation.your-stories-description',
      backgroundImage: `${imageRoot}/gradient-family-1.jpg`,
      foregroundImage: `${imageRoot}/onboarding-stories.png`,
      next: FAMILY_STORIES_PATH,
      invitationPage: {
        gradient: '',
        textIsLeft: false,
        backgroundImage: `${cdnRoot}/connect/tutorial/v1/fishing.jpeg`,
      },
    },
    {
      path: FAMILY_STORIES_PATH,
      title: 'invitation.family-stories',
      icon: `${imageRoot}/heart-icon.svg`,
      description: 'invitation.family-stories-description',
      backgroundImage: `${imageRoot}/gradient-mountains.jpg`,
      foregroundImage: `${imageRoot}/onboarding-completed.png`,
      next: FAMILY_FEED_PATH,
      invitationPage: {
        textIsLeft: true,
        backgroundImage: `${cdnRoot}/connect/tutorial/v1/mountain-man.jpeg`,
      },
    },
    {
      path: FAMILY_FEED_PATH,
      title: 'invitation.family-feed',
      icon: `${imageRoot}/feed-bars-icon.svg`,
      description: 'invitation.family-feed-description',
      backgroundImage: `${imageRoot}/gradient-family-2.jpg`,
      foregroundImage: `${imageRoot}/onboarding-feed.png`,
      next: () => {
        return showTemple ? TEMPLE_PATH : ACTIVITIES_PATH
      },
      invitationPage: {
        gradient: '',
        textIsLeft: false,
        backgroundImage: `${cdnRoot}/connect/tutorial/v1/family-beach.jpeg`,
      },
    },
    {
      path: TEMPLE_PATH,
      title: 'invitation.temple',
      icon: `${imageRoot}/temple-icon.svg`,
      description: 'invitation.temple-description',
      backgroundImage: `${imageRoot}/gradient-temple.jpg`,
      foregroundImage: `${imageRoot}/onboarding-temple.png`,
      next: ACTIVITIES_PATH,
      invitationPage: {
        gradient: '',
        textIsLeft: true,
        backgroundImage: `${cdnRoot}/connect/tutorial/v1/temple.jpeg`,
      },
    },
    {
      path: ACTIVITIES_PATH,
      title: 'invitation.activities',
      icon: `${imageRoot}/star-icon.svg`,
      description: 'invitation.activities-description',
      backgroundImage: `${imageRoot}/gradient-activities.jpg`,
      foregroundImage: `${imageRoot}/onboarding-activities.png`,
      next: INVITE_FAMILY_MEMBERS_PATH,
      invitationPage: {
        gradient: '',
        textIsLeft: false,
        backgroundImage: `${cdnRoot}/connect/tutorial/v1/heart-hands.jpeg`,
      },
    },
  ]
}
